import { helpers } from "vuelidate/lib/validators";

export default (number) =>
  helpers.withParams({ type: "lessThan" }, function(value, parentVm) {
    return (value || 0) < helpers.ref(number, this, parentVm);
  });
